import { useState, useEffect } from "react"
import { getInitials } from "../../Utils/Constants/Constants";
import {
  NotificationActiveIcon,
  SupportIcon,
  UserIcon
} from "../../Assets/assets";

export default function Header(props) {

  const [logos, setLogos] = useState({ dark: null, light: null });

  useEffect(() => {
    const loadLogos = async () => {
      try {
        const darkLogo = await import(
          `../../Assets/${process.env.REACT_APP_LOGO}/logoDark.svg`
        );
        const lightLogo = await import(
          `../../Assets/${process.env.REACT_APP_LOGO}/logoLight.svg`
        );      
        setLogos({
          dark: darkLogo.default,
          light: lightLogo.default
        });
      } catch (error) {
        console.error("Failed to load logos:", error);
      }
    };

    loadLogos();
  }, []);

  return (
    <div className="padding-large inherit-parent-width">
      <div className="display-flex flex-justify-content-space-between flex-align-items-center">
        <div className="display-flex flex-align-items-center flex-justify-content-center">
          <img
            src={props.theme === "dark" ? logos.light : logos.dark}
            alt="DRRSB Logo"
            height={36}
          />
          {/* <div className="padding-left-default font-color-primary">CCMS</div> */}
        </div>
        <div className="display-flex">
          <div
            style={{
              height: "36px",
              width: "36px",
              borderRadius: "100%"
            }}
            onClick={props.onSupportClick}
            className="cursor-pointer ripple-element flex-align-items-center flex-justify-content-center display-flex"
            data-cy="SUPPORT-ICON"
          >
            <SupportIcon
              width="20px"
              height="20px"
              color={props.isSupportActive ? "var(--secondaryColor)" : "var(--tertiaryColor)"}
            />
          </div>
          <div
            style={{
              height: "36px",
              width: "36px",
              borderRadius: "100%"
            }}
            onClick={props.onNotificationClick}
            className="cursor-pointer margin-left-large ripple-element"
            data-cy="NOTIFICATION-ICON"
          >
            <NotificationActiveIcon
              color="var(--tertiaryColor)"
              showDot={props.showNotificationDot}
            />
          </div>
          <div
            style={{
              height: "36px",
              width: "36px",
              borderRadius: "100%",
              backgroundColor: "var(--tertiaryColor3)"
            }}
            onClick={props.onProfileClick}
            className="cursor-pointer margin-left-large flex-justify-content-center flex-align-items-center ripple-element"
            data-cy="profileButton"
          >
            {props.name && <ProfileNamePlaceHolderIcon name={props.name} />}
            {!props.name && (
              <UserIcon width="12" height="12" color="var(--tertiaryColor6)" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const ProfileNamePlaceHolderIcon = (props) => {
  return (
    <div
      style={{
        height: "36px",
        width: "36px",
        borderRadius: "100%"
      }}
      className="flex-align-items-center flex-justify-content-center font-size-small font-color-tertiaryColor6"
    >
      {getInitials(props.name)}
    </div>
  );
};
